module.exports = __webpack_public_path__ + "static/media/tutorial2bot.5763309c.svg";